export default {
  403: {
    tips: 'sorry, you don not have permission to access this page. Please contact the creator through WeCom',
    back: 'Back to homepage',
  },
  404: {
    subtitle: 'Sorry, the page is not found',
    back: 'Back to homepage',
  },
  500: {
    subtitle: 'Sorry, the server is error',
    back: 'Back to homepage',
  },
  fail: {
    title: 'Create fail',
    subtitle: 'Sorry, your project creation has failed',
    back: 'Back to homepage',
    modify: 'Back to modify',
  },
  success: {
    title: 'Project is created',
    subtitle: 'Contact the person in charge of distributing the application',
    back: 'Back to homepage',
    progress: 'Check Progress',
  },
  maintenance: {
    title: 'System maintenance',
    subtitle: 'Please try again later',
    back: 'Back to homepage',
  },
  browserIncompatible: {
    title: 'browser is incompatible',
    subtitle: 'the browser version you are using is too outdated to open the current webpage.',
    back: 'Back to homepage',
    recommend: 'Medical Pressure Admin Platform recommends the following browsers',
  },
  networkError: {
    title: 'Network Error',
    subtitle: 'Network error, please try again later',
    back: 'Back to homepage',
    reload: 'Reload',
  },
};
